module.exports = __webpack_public_path__ + "media/bootstrap-icons/gear-fill-139a2971.svg";